import React, { useState } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import { criarAgentesRecebedoresDs } from "../../DataSources";
import { LoadIndicator } from "devextreme-react/load-indicator";
import showError from "../../AppServices";
import apiAxios from "../../api-axios";
import notify from "devextreme/ui/notify";
import showReport from "../../showReport";

const ArrecadacaoGeral = () => {
  const [estado, setEstado] = useState({
    tipoData: "credito",
    dataInicial: undefined,
    dataFinal: undefined,
    agenteRecebedorId: undefined,
    tipoBaixa: "T",
    leiaute: "default",
    natureza: "",
    somenteDiat: 0,
    tipoDeLancamento: ""
  });

  const [botao, setBotao] = useState({
    loadIndicatorVisivel: false,
    texto: "Visualizar PDF",
  });

  const dataOptions = {
    editorType: "dxSelectBox",
    dataSource: [
      { id: "pagamento", descricao: "Data de Pagamento" },
      { id: "credito", descricao: "Data de Crédito" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  const agenteRecebedorOptions = {
    editorType: "dxSelectBox",
    searchEnabled: true,
    dataSource: criarAgentesRecebedoresDs(),
    valueExpr: "id",
    displayExpr: "descricao",
    searchMode: "contains",
    placeholder: " "
  };

  const tipoDeBaixaOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: "T", descricao: "TODOS" },
      { id: "M", descricao: "MANUAL" },
      { id: "A", descricao: "AUTOMATICA" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  const leiauteOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: "default", descricao: "GERAL" },
      { id: "receita", descricao: "GERAL - POR RECEITA" },
      { id: "<contabilidade>", descricao: "CONTABILIDADE" },
      { id: "<receita>", descricao: "RESUMO DE RECEITAS" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  const naturezaOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: "", descricao: " " },
      { id: "t", descricao: "TRIBUTARIA" },
      { id: "nt", descricao: "NAO TRIBUTARIA" }
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };


  const somenteDiatOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: 0, descricao: " " },
      { id: 2, descricao: "NORMAL" },
      { id: 1, descricao: "DIVIDA ATIVA" }
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };

  const tipoLancamentoOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: [
      { id: "", descricao: " " },
      { id: "IPTU", descricao: "IPTU" },
      { id: "ITBI", descricao: "ITBI" },
      { id: "TAXA", descricao: "LANCAMENTOS DIVERSOS" },
      { id: "TLLF", descricao: "ALV. FUNCIONAMENTO" },
      { id: "TLAS", descricao: "ALV. SANITARIO" },
      { id: "TLFHE", descricao: "ALV. HORARIO ESPECIAL" },
      { id: "TLTA", descricao: "ALV. DE VEICULOS" },
      { id: "TLVP", descricao: "ALV. DE PUBLICIDADE" },
      { id: "TLAC", descricao: "ALV. DE CONSTRUCAO" },
      { id: "TLHB", descricao: "HABITE-SE" },
      { id: "TLAD", descricao: "ALV. DIVERSOS" },
      { id: "ISS", descricao: "ISS" },
      { id: "DIVIDA ATIVA", descricao: "DIVIDA ATIVA" },
    ],
    valueExpr: "id",
    displayExpr: "descricao",
  };


  function ok() {
    setBotao({
      loadIndicatorVisivel: true,
      texto: "Carregando",
    });

    const request = { ...estado, prefeituraId: UserInfo.getPrefeitura() };
    
    showReport("/report/relatorio_arrecadacao", request);
    
    setBotao({
      loadIndicatorVisivel: false,
      texto: "Visualizar PDF",
    });

    return;
  }

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={estado} colCount={4}>
          <GroupItem
            caption="Relatório de Arrecadação Geral"
            colSpan={4}
            colCount={3}
          >
            <SimpleItem
              dataField={"tipoData"}
              editorType={"dxSelectBox"}
              editorOptions={dataOptions}
            >
              <Label text="Arrecadação" />
            </SimpleItem>

            <SimpleItem
              dataField={"dataInicial"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data de Início" />
            </SimpleItem>

            <SimpleItem
              dataField={"dataFinal"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data do Fim" />
            </SimpleItem>



            <SimpleItem
              dataField={"tipoDeLancamento"}
              editorType={"dxSelectBox"}
              editorOptions={tipoLancamentoOptions}
            >
              <Label text="Tipo de Lançamento" />
            </SimpleItem>

            <SimpleItem
              dataField={"natureza"}
              editorType={"dxSelectBox"}
              editorOptions={naturezaOptions}
            >
              <Label text="Natureza" />
            </SimpleItem>

            <SimpleItem
              dataField={"somenteDiat"}
              editorType={"dxSelectBox"}
              editorOptions={somenteDiatOptions}
            >
              <Label text="Tipo Arrecadação" />
            </SimpleItem>

            <SimpleItem
              dataField={"agenteRecebedorId"}
              editorType={"dxSelectBox"}
              editorOptions={agenteRecebedorOptions}
              colSpan={3}
            >
              <Label text="Agente Recebedor" />
            </SimpleItem>

            <SimpleItem
              dataField={"imoveisIds"}
              colSpan={3}
            >
              <Label text="Imóveis" />
            </SimpleItem>

            <SimpleItem
              dataField={"contribuintesIds"}
              colSpan={3}
            >
              <Label text="Contribuintes" />
            </SimpleItem>

            <SimpleItem
              dataField={"receitasIds"}
              colSpan={3}
              editorType="dxTextArea"
              editorOptions={{ height: 60 }}
            >
              <Label text="Receitas" />
            </SimpleItem>

            <SimpleItem
              dataField={"tipoBaixa"}
              editorType={"dxSelectBox"}
              editorOptions={tipoDeBaixaOptions}
            >
              <Label text="Tipo de Baixa" />
            </SimpleItem>

            <SimpleItem
              dataField={"leiaute"}
              editorType={"dxSelectBox"}
              editorOptions={leiauteOptions}
              colSpan={2}
            >
              <Label text="Leiaute" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <Button
              width={160}
              style={{ display: "inline-block", justifyContent: "center" }}
              type="success"
              disabled={botao.loadIndicatorVisivel}
              onClick={() => ok()}
            >
              <LoadIndicator
                className="button-indicator"
                id="small-indicator"
                height={20}
                width={20}
                visible={botao.loadIndicatorVisivel}
                style={{ marginRight: "10px", verticalAlign: "middle" }}
              />
              <span className="dx-button-text">{botao.texto}</span>
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ArrecadacaoGeral;
